import React from "react";
import { FieldError } from "react-hook-form";

interface InputFieldProps {
  type: "text" | "password" | "email" | "number";
  placeholder: string;
  register: any;
  disabled?: boolean;
  rows?: number
  error: FieldError | undefined;
  classes?: string,
  updatedStyle?:string

}

const FormHookTextArea: React.FC<InputFieldProps> = ({
  type,
  placeholder,
  register,
  classes,
  disabled,
  rows = 5,
  error,
  updatedStyle

}) => {


  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   console.log(e.target.value);
  // };
  return (
    <>
      <textarea
        disabled={disabled}
        rows={rows}
        // onChange={handleInputChange}
        className={`${updatedStyle? updatedStyle: ` w-full px-4 py-3 bg-p-gray rounded-xl    focus:outline-none  text-gray-600 ${classes}`}`}
        type={type}
        placeholder={placeholder}
        {...register}
      />
      {error && (
        <p className="text-red-500 text-xs mt-1 py-">{error.message}</p>
      )}
    </>
  );
};

export default FormHookTextArea;
